module.exports = __webpack_public_path__ + "img/img-3-5mobile.f6867712.webp";